/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { styles } from '@material-ui/pickers/views/Calendar/Calendar';
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import {
  textMatcherWith2Decimal,
  cellRenderer,
} from '../../../../SharedModules/utilities/utilities';

const fourDecimalRenderer = (params, a) => {
  const { value } = params;
  const { isTextColorRed } = params.colDef;
  const { printPrefixValue } = params.colDef;
  const { printPostfixValue } = params.colDef;
  if (value === '') return '';
  if (value < 0) {
    return (
      <span
        style={{
          color: isTextColorRed ? '#eb0000' : '',
        }}
      >
        {`(${printPrefixValue ? `${printPrefixValue} ` : ''}${parseFloat(value)
          .toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
          .substring(1)})` + `${printPostfixValue || ''}`}
      </span>
    );
  }
  if (value > -1) {
    return (
      <span>
        {`${
          (printPrefixValue ? `${printPrefixValue} ` : '') +
          parseFloat(value).toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
        }${printPostfixValue || ''}`}
      </span>
    );
  }
  return params.value || '';
};

const comparator = (a, b) => {
  return parseFloat(a) - parseFloat(b);
};

// Custom Comparator for Quarter
const comparatorQtr = (a, b) => {
  const splittedQtrA = a.split('Q');
  const splittedQtrB = b.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

// Table head for NDC report
export const TableHead = [
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'desc',
    minWidth: Styles.Width_120,
    cellRenderer: 'GenericCodeTextBox',
    comparator: comparatorQtr,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Status',
    field: 'statuscd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    wrapText: true,
    // autoHeight: true,
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Units',
    field: 'totreimbursedunits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    isCount: true,
    minWidth: Styles.Width_120,
    wrapText: true,

    isTextColorRed: true,
    cellRenderer: fourDecimalRenderer,
    comparator,
    excelAlignment: 'right',
    alignment: 'right',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Current Units',
    field: 'numofunits',
    editable: false,
    suppressMenu: false,
    wrapText: true,

    sortable: true,
    isCount: true,
    minWidth: Styles.Width_120,

    cellRenderer: fourDecimalRenderer,
    comparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    excelAlignment: 'right',
    alignment: 'right',
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    alignment: 'right',
  },
  {
    headerName: 'Adjusted Units',
    field: 'adjustedUnits',
    editable: false,
    suppressMenu: false,
    wrapText: true,

    sortable: true,
    isCount: true,
    excelAlignment: 'right',
    alignment: 'right',

    minWidth: Styles.Width_135,
    isTextColorRed: true,
    cellRenderer: fourDecimalRenderer,
    comparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
  },
  {
    headerName: 'Disputed Units',
    field: 'disputedunits',
    editable: false,
    wrapText: true,

    suppressMenu: false,
    sortable: true,
    isTextColorRed: true,
    isCount: true,
    excelAlignment: 'right',
    alignment: 'right',
    minWidth: Styles.Width_135,
    cellRenderer: fourDecimalRenderer,
    comparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
  },
  {
    headerName: 'Original Invoice Amount',
    field: 'originalInvoiceAmount',
    editable: false,
    wrapText: true,
    // autoHeight: true,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_135,
    cellRenderer,
    isTextColorRed: true,
    printPrefixValue: '$',
    isAmount: true,
    alignment: 'right',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
  {
    headerName: 'Current Invoice Amount',
    field: 'currentInvoiceAmount',
    editable: false,
    wrapText: true,
    // autoHeight: true,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_130,
    cellRenderer,
    isAmount: true,
    alignment: 'right',
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
  {
    headerName: 'Amount Paid to  Date',
    field: 'paid_amt',
    editable: false,
    wrapText: true,
    // autoHeight: true,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_130,
    cellRenderer,
    isTextColorRed: true,
    isAmount: true,
    alignment: 'right',
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
];
